import { useTranslation } from 'react-i18next';
import { PropertySeasonalRule } from 'models/seasonality/SeasonalCancellationPolicy';
import { parseISO } from 'date-fns';
import {
  SeasonalRuleTooltipContent,
  SeasonalRuleTooltipName,
  SeasonalRuleTooltipRow,
  SeasonalRuleTooltipSectionTitle,
} from './SeasonalRuleView.styles';

const SeasonalRuleTooltip = ({ rule }: { rule: PropertySeasonalRule }) => {
  const { t } = useTranslation();

  return (
    <SeasonalRuleTooltipContent>
      <SeasonalRuleTooltipName>{rule.ruleName}</SeasonalRuleTooltipName>
      <SeasonalRuleTooltipRow>
        {t('pageCalendar.seasonalRuleTooltip.dateRange', {
          startDate: t('common.dateMedium', { date: parseISO(rule.startDate) }),
          endDate: t('common.dateMedium', { date: parseISO(rule.endDate) }),
        })}
      </SeasonalRuleTooltipRow>

      <SeasonalRuleTooltipSectionTitle>
        {t('pageCalendar.seasonalRuleTooltip.cancellationPolicies')}
      </SeasonalRuleTooltipSectionTitle>
      {rule.cancellationPolicies.length === 0 ? (
        <SeasonalRuleTooltipRow>
          {t('pageCalendar.seasonalRuleTooltip.empty')}
        </SeasonalRuleTooltipRow>
      ) : (
        rule.cancellationPolicies.map((policy) => (
          <SeasonalRuleTooltipRow key={policy.channel}>
            <strong>
              {t(`pageCalendar.seasonalRuleTooltip.channels.${policy.channel}`)}
              :
            </strong>{' '}
            {policy.displayLabel}
          </SeasonalRuleTooltipRow>
        ))
      )}
    </SeasonalRuleTooltipContent>
  );
};

export default SeasonalRuleTooltip;
